import { UpdatableModel } from './updatable-model';
export class AuditProperty extends UpdatableModel<AuditProperty> {
  id: string;
  propertyName: string;
  oldvalue: string;
  newvalue: string;
}
